import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    scheduleGroups: [],
    loading: false,
    // Как в manageTeams: `loading` подменяет вкладку лоадером, форма не
    // должна пропадать до ответа сервера.
    saving: false
  }),
  mutations: {
    setScheduleGroups(state, scheduleGroups) {
      state.scheduleGroups = scheduleGroups
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setSaving(state, saving) {
      state.saving = saving
    }
  },
  actions: {
    async fetchScheduleGroups(context) {
      return withLoading(async () => {
        try {
          const response = await api.get("/manage/schedule_groups")
          context.commit("setScheduleGroups", response.data)
        } catch (error) {
          context.commit("setScheduleGroups", [])
        }
      }, context)
    },

    async createScheduleGroup(context, params) {
      context.commit("setSaving", true)

      try {
        const response = await api.post("/manage/schedule_groups", params)
        context.commit("setScheduleGroups", response.data)
      } finally {
        context.commit("setSaving", false)
      }
    },

    async updateScheduleGroup(context, { id, ...params }) {
      context.commit("setSaving", true)

      try {
        const response = await api.put(`/manage/schedule_groups/${id}`, params)
        context.commit("setScheduleGroups", response.data)
      } finally {
        context.commit("setSaving", false)
      }
    },

    async deleteScheduleGroup(context, id) {
      context.commit("setSaving", true)

      try {
        const response = await api.delete(`/manage/schedule_groups/${id}`)
        context.commit("setScheduleGroups", response.data)
      } finally {
        context.commit("setSaving", false)
      }
    }
  }
}
